var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "dvidsContainer", staticClass: "dvidsvideo-container" },
    [
      _c("div", { staticClass: "video-overlay" }),
      _vm._v(" "),
      _c("div", { staticClass: "DvidsVideo" }, [
        _c(
          "video",
          {
            staticClass: "dvidsPlayer",
            attrs: {
              id: _vm.videoId,
              width: "100%",
              preload: "auto",
              controls: "",
              src: _vm.videoSrc,
              poster: _vm.videoImg,
            },
          },
          [
            _c("track", {
              attrs: { kind: "subtitles", src: _vm.captionsSrc, srclang: "en" },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }